import AEMWrapper from "aem/ComponentWrapper";
import loadable from "@loadable/component";
import React from "react";

export default AEMWrapper(
  {
    type: "rh/components/content/dm-image-smart-crop-v2",
    config: {
      emptyLabel: "Dynamic Media Smart Crop Image 2 - RH",

      isEmpty: function (props: any) {
        return (
          !props ||
          !props.fileReference ||
          props.fileReference.trim().length < 1
        );
      }
    }
  },
  loadable(
    () =>
      import(/* webpackChunkName: "component-rh-dm-smart-crop-image-v2" */ "."),
    {
      fallback: <></>
    }
  )
);
